export const VERTICALS = [
  {
    id:          'home-services',
    label:       'Home Services',
    collective:  'Home Services Collective',
    tagline:     'Plumbers, roofers, landscapers, painters & HVAC',
    bg:          'bg-brand-blue',
    text:        'text-white',
    hex:         '#009FE3',
  },
  {
    id:          'event-planning',
    label:       'Event Planning',
    collective:  'Home Services Collective',
    tagline:     'Caterers, DJs, photographers, florists & venues',
    bg:          'bg-green-600',
    text:        'text-white',
    hex:         '#16a34a',
  },
  {
    id:          'health-wellness',
    label:       'Health & Wellness',
    collective:  'Wellness Collective',
    tagline:     'Chiropractors, dentists, gyms, massage & med spas',
    bg:          'bg-purple-600',
    text:        'text-white',
    hex:         '#9333ea',
  },
  {
    id:          'restaurants',
    label:       'Restaurants',
    collective:  'Dining Collective',
    tagline:     'Pizza, tacos, burgers, sushi & neighborhood dining',
    bg:          'bg-orange-500',
    text:        'text-white',
    hex:         '#f97316',
  },
  {
    id:          'real-estate',
    label:       'Real Estate',
    collective:  'Real Estate Collective',
    tagline:     'Agents, mortgage brokers, title companies & movers',
    bg:          'bg-teal-600',
    text:        'text-white',
    hex:         '#0d9488',
  },
];

export const getVertical = (id) =>
  VERTICALS.find(v => v.id === id) ?? VERTICALS[0];
